import { saveProfile } from './ProfileService';
import { extractError } from '../../api/ErrorUtil';

export const profileFormDataInitialState = {
  userName: "",
  firstName: "",
  lastName: "",
  companyName: "",
  address: "",
  city: "",
  state: "ON",
  zip: "",
  mobilePhoneNumber: "",
  officePhoneNumber: "",
  email: "",
  country: "CA",
  readOnly: false,
  errors: {}
}

export const AsyncProfileFormDataHandlers = {
  FORM_SUBMIT: ({ dispatch, getState, signal }) => async (action) => {
    let { formData } = action.payload;
    dispatch({ type: 'FORM_SUBMITTING' });
    try {
      let profileResponse = await saveProfile(formData);
      dispatch({ type: 'FORM_SUBMIT_SUCCESS', payload: profileResponse });
    } catch (error) {
      let errorMsg = extractError(error);
      dispatch({ type: 'FORM_SUBMIT_FAIL', payload: { error: errorMsg } });
    }

  }
};

export const ProfileFormDataReducer = (state, action) => {

  if (action.type === 'FETCH_PROFILE') {
    return {
      readOnly: true,
      status: "Fetching Profile..."

    }
  }

  if (action.type === 'POPULATE_FORM') {
    return {
      readOnly: false,
      status: "",
      ...action.payload
    }
  }

  if (action.type === 'FIELD_CLEAR') {
    return profileFormDataInitialState;
  }

  if (action.type === 'FORM_SUBMITTING') {
    return {
      ...state,
      readOnly: true,
      status: "Saving profile...",
      errors: {}
    }
  }

  if (action.type === 'FORM_SUBMIT_SUCCESS') {
    let data = action.payload;
    let newState = {
      ...state,
      status: "",
      readOnly: false,
      infoMessage: data.message
    };
    return newState;
  }

  if (action.type === 'FORM_SUBMIT_FAIL') {
    let { error } = action.payload;
    let newState = {
      ...state,
      status: "",
      errors: error
    };
    return newState;
  }

  if (action.type === 'CLEAR_INFO_AND_ERROR') {
    return {
      ...state,
      infoMessage: "",
      errors: {}
    }
  }
  if (action.type === 'FIELD_EDIT') {
    const { name, value } = action.payload;
    let newState = {
      ...state,
      [name]: value

    };
    return newState;
  }
  //the following is for form edit and hence there should be a payload.
  //otherwise just return state

  if (!action.payload) {
    return state;
  }
}
